/**
 * ToastViewport — 알림 토스트 스택 컨테이너 (Shell 전속)
 *
 * 소유: 프레임 팀. 화면 우하단 고정, 세로 스택(최신이 아래). 위치/방향은 UI팀 확정 시 조정.
 * [확인하기] → 메뉴 코드(webMenuCode) 기반 딥링크(NotificationsPage.tsx와 동일 리졸버) + 읽음
 * 처리 후 닫기.
 */
import { useNavigate } from 'react-router';
import { useNotifications } from './NotificationProvider';
import { NotificationToast } from './NotificationToast';
import { showInfoToast } from './InfoToast';
import { useAllMenuTree, resolveMenuCodeAction } from '../../../registry/menu-tree';

const APP_ONLY_MESSAGE = '앱 전용 화면입니다. 인디피아 앱을 이용해주세요.';

export function ToastViewport() {
  const { toasts, dismissToast, markRead } = useNotifications();
  const navigate = useNavigate();
  const { data: menuTree } = useAllMenuTree();

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed bottom-4 right-4 z-toast flex flex-col-reverse gap-2">
      {toasts.map((t) => (
        <div key={t.uid} className="pointer-events-auto">
          <NotificationToast
            item={t.item}
            onDismiss={() => dismissToast(t.uid)}
            onConfirm={(item) => {
              markRead(item.id);
              const action = resolveMenuCodeAction(menuTree, item.webMenuCode, item.appMenuCode, item.targetId, item.siteId);
              if (action.kind === 'route') void navigate(action.path);
              else if (action.kind === 'other-platform') showInfoToast(APP_ONLY_MESSAGE);
              dismissToast(t.uid);
            }}
          />
        </div>
      ))}
    </div>
  );
}
